import { render, staticRenderFns } from "./SpecimensInactives.vue?vue&type=template&id=2a839eb0&scoped=true"
import script from "./SpecimensInactives.vue?vue&type=script&lang=js"
export * from "./SpecimensInactives.vue?vue&type=script&lang=js"
import style0 from "./SpecimensInactives.vue?vue&type=style&index=0&id=2a839eb0&prod&lang=scss&scoped=true"
import style1 from "./SpecimensInactives.vue?vue&type=style&index=1&id=2a839eb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a839eb0",
  null
  
)

export default component.exports